export const orange50 = "#fdf3e9";
export const orange100 = "#fdefda";
export const orange200 = "#fcdfb5";
export const orange300 = "#facf91";
export const orange400 = "#f9bf6c";
export const orange500 = "#f8af48";
export const orange600 = "#f6963b";
export const orange700 = "#f47f2e";
export const orange800 = "#f26721";
export const orange900 = "#f04f14";
export const orange1000 = "#e93605";
export const orangeA100 = "#fdef81";
export const orangeA200 = "#fbd76c";
export const orangeA400 = "#f48724";
export const orangeA500 = "#ed4805";
export const orangeA1000 = "#563d19";
